<template lang="pug">
.mt-4
  div
    v-dialog(v-model="flowDialog", max-width="800")
      template(v-slot:activator="{ on }")
        v-btn(color="primary", v-on="on")
          v-icon(left) mdi-folder-plus
          | Add Flow
      v-card
        v-card-title Add flow
        v-card-text
          v-text-field(v-model="flowName", label="Flow name")
        v-card-actions
          v-spacer
          v-btn(text, @click="cancel") cancel
          v-btn(text, @click="save") save
    v-dialog(v-model="dialog", max-width="1000")
      v-card
        v-card-title Edit rules
        v-card-text
          v-row(align="center")
            v-col(xs="3")
              span Value #1
            v-col(xs="3")
              v-select(:items="actionTypes", label="Action type", hide-details)
    .group.mt-4
      Flow(
        v-for="(flow, i) in flows",
        :key="i",
        :data="flow",
        :questions="questions",
        @changeOrder="changeOrder",
        @add="addStep",
        @save="saveStep",
        @refresh="refreshFlows",
        @checkFlow="checkFlow"
      )
</template>

<script>
import Flow from "./Flow";

export default {
  components: {
    Flow,
  },

  props: ["tab"],

  watch: {
    tab() {
      this.refreshData();
    },
  },

  data() {
    return {
      flows: [],
      flowDialog: false,
      flowName: "",
      questions: [],
      dialog: false,
      actionTypes: ["Next", "To question", "Rule"],
    };
  },

  methods: {
    checkFlow(id) {
      this.axios.get(`/admin/flow/${id}/check`).then((resp) => {
        console.log("hi");
        this.flows.forEach((f, ind) => {
          console.log(id, f.ID);
          if (id == f.ID) {
            console.log("set");
            this.$set(this.flows, ind, resp.data);
          }
        });
      });
    },

    cancel() {
      this.flowDialog = false;
      this.flowName = "";
    },

    save() {
      this.axios
        .post("/admin/flow", { name: this.flowName })
        .then(() => {
          this.cancel();
          this.refreshFlows();
        })
        .catch((e) => {
          this.$message.errorFromServer(e);
        });
    },

    refreshData() {
      this.refreshFlows();
      this.getQuestions();
    },

    refreshFlows() {
      this.getFlows();
    },

    saveStep(flowID, step) {
      step.flow_id = flowID;
      delete step.question;
      this.axios
        .put("/admin/flow/" + flowID + "/steps", step)
        .then(() => {
          this.getFlows();
        })
        .catch((e) => {
          this.$message.errorFromServer(e);
        });
    },

    addStep(flowID, step) {
      step.flow_id = flowID;
      delete step.question;
      this.axios
        .post("/admin/flow/" + flowID + "/steps", step)
        .then(() => {
          this.refreshData()
        })
        .catch((e) => {
          this.$message.errorFromServer(e);
        });
    },

    changeOrder(arr, id) {
      let ind;
      let flow;
      this.flows.forEach((f, i) => {
        if (f.ID === id) {
          flow = f;
          ind = i;
        }
      });

      this.axios
        .put("/admin/flow/" + id + "/steps/index", {
          steps_id: arr.map((f) => f.ID),
        })
        .then(() => {
          this.refreshData()
        })
        .catch((e) => {
          this.$message.errorFromServer(e);
        });
      flow.steps = arr;
      this.$set(this.flows, ind, flow);
    },

    getQuestions() {
      this.axios.get("/admin/question").then((resp) => {
        this.questions = resp.data;
      });
    },

    getFlows() {
      this.axios
        .get("/admin/flow")
        .then((resp) => {
          this.flows = resp.data;
        })
        .catch((e) => {
          this.$message.errorFromServer(e);
        });
    },
  },

  mounted() {
    this.refreshData();
  },
};
</script>
